import { DataProvider, withLifecycleCallbacks } from 'react-admin'
import { parserParamsForGetList } from '~/utils/dataProviderParams'
import {
  CreateChat,
  Response,
  ResponseArrayNumbers,
  ResponseArrayObjects,
  ResponseObject,
} from '~/utils/types'
import ChatApi from '~/api/chat-api'
import { removeObjectsWithNullOrUndefinedValues } from '~/utils/transformRelation'
import { transformListToDict } from '~/modules/entity'

export const baseChatsProvider: DataProvider = {
  async getList(resource: string, params): Promise<Response> {
    const filter = parserParamsForGetList(params, resource)
    const res = await ChatApi.getList({ ...filter })
    console.log("list-chats", res.data)
    return { data: res.data.rows, total: res.data.count }
  },
  async getMany(
    resource: string,
    { ids }: { ids: ResponseArrayNumbers }
  ): Promise<ResponseArrayObjects> {
    const res = await ChatApi.getList({ filter: { id: ids } })
    return { data: res.data.rows }
  },
  async getOne(
    resource: string,
    { id }: { id: number }
  ): Promise<ResponseObject> {
    const res = await ChatApi.getOne(id)
    return { data: res.data }
  },
  async create(
    resource: string,
    { data: { name, typeId, entityId, users } }: { data: CreateChat }
  ): Promise<ResponseObject> {
    const res = await ChatApi.create({ name, typeId, entityId, users })
    return { data: res.data }
  },
}

export const chatProvider: DataProvider = withLifecycleCallbacks(
  baseChatsProvider,
  [
    {
      resource: 'chats',
      afterGetList: async (params, dataProvider: DataProvider) => {
        const paramsWithoutNullValues =
          removeObjectsWithNullOrUndefinedValues(params)

        const updatedParams = paramsWithoutNullValues.data.map(d => {
          const user = d?.members?.find(u => u.userId !== 1)?.user
          if (user) {
            d.user = {
              ...user,
              properties: transformListToDict(user.properties),
            }
          }
          return d
        })

        return {
          ...paramsWithoutNullValues,
          data: updatedParams,
        }
      },
    },
  ]
)
